import { render } from "./NavigationItem.vue?vue&type=template&id=766cbaf7&scoped=true&lang=pug"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"

import "./NavigationItem.vue?vue&type=style&index=0&id=766cbaf7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766cbaf7"]])

export default __exports__